import { render, staticRenderFns } from "./Sider.vue?vue&type=template&id=1603b86c&scoped=true&"
import script from "./Sider.vue?vue&type=script&lang=js&"
export * from "./Sider.vue?vue&type=script&lang=js&"
import style0 from "./Sider.vue?vue&type=style&index=0&id=1603b86c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1603b86c",
  null
  
)

export default component.exports